import React from "react";

import {
  STEP_LABELS,
  getActiveStepIds,
  getStepOrder,
  getStepVisual,
  isStepSelected,
} from "../characterCreatorUtils.js";

export default function Stepper({ state, furthestUnlockedOrder, onStepChange }) {
  const activeStepIds = getActiveStepIds(state);

  return (
    <nav
      className="stepper"
      aria-label="Etapas do wizard"
      style={{ "--stepper-count": activeStepIds.length }}
    >
      {activeStepIds.map((stepId, index) => {
        const visual = getStepVisual(stepId);
        const staticOrder = getStepOrder(stepId);
        const isUnlocked = staticOrder <= furthestUnlockedOrder;
        const isCurrent = stepId === state.currentStepId;
        const isCompleted = staticOrder < getStepOrder(state.currentStepId);
        const hasSelection = isStepSelected(stepId, state);
        const classes = ["step-item"];
        if (stepId === "subclasse") classes.push("step-secret");
        if (isCurrent) classes.push("active");
        if (isCompleted) classes.push("completed");
        if (!isUnlocked) classes.push("locked");
        const numberDisplay = hasSelection ? "✓" : index + 1;

        return (
          <button
            key={stepId}
            type="button"
            className={classes.join(" ")}
            style={{
              "--step-item-accent": visual.accent,
              "--step-item-soft": visual.soft,
              "--step-item-glow": visual.glow,
            }}
            onClick={() => {
              if (isUnlocked) onStepChange(stepId);
            }}
          >
            <span className="step-thumb-wrap">
              <span className="step-thumb">
                <img src={visual.image} alt={STEP_LABELS[stepId]} loading="lazy" />
              </span>
              <span className="step-num">{numberDisplay}</span>
            </span>
            <span className="step-copy">
              <span className="step-title">{STEP_LABELS[stepId]}</span>
              <span className="step-hint">{visual.hint}</span>
            </span>
          </button>
        );
      })}
    </nav>
  );
}
